import React, { FC } from 'react';
import { Ntry, Prtry } from '@shared/api';
import { TextTooltip } from '@shared/UI';
import { formats } from '@shared/utils';
import { acceptUTC } from '@widgets/ISOReportsTable/components/ISOReportsDrawer/lib';
import { debitTransactionCodes, creditTransactionCodes } from './constants';
import './Transactions.scss';

const formatTransactionValue = (value: number, type: string) => {
    return `${type == 'DBIT' ? '-' : '+'}$${value}`;
};

interface ITransactionInfo {
    id?: string;
    prtry: Prtry;
    comment: string;
    date?: string;
    amount: string;
}

interface ITransactionInfoProps {
    transactionInfo: ITransactionInfo;
}

const TransactionInfo: FC<ITransactionInfoProps> = (props) => {
    const { transactionInfo } = props;

    return (
        <div className='transaction-info__info-items'>
            {!!transactionInfo.id && (
                <div className='transaction-info__info-item'>
                    <span className='transaction-info__info-header'>ID:</span>
                    <span className='transaction-info__info-content'>{transactionInfo.id}</span>
                </div>
            )}
            {!!transactionInfo.date && (
                <div className='transaction-info__info-item'>
                    <span className='transaction-info__info-header'>Date:</span>
                    <span className='transaction-info__info-content'>
                        {acceptUTC(transactionInfo.date, formats.fullTime)}
                    </span>
                </div>
            )}
            {!!transactionInfo.amount && (
                <div className='transaction-info__info-item'>
                    <span className='transaction-info__info-header'>Amount:</span>
                    <span className='transaction-info__info-content'>{transactionInfo.amount}</span>
                </div>
            )}
            {!!transactionInfo.prtry && (
                <div className='transaction-info__info-item'>
                    <span className='transaction-info__info-header'>Transaction Type:</span>
                    <span className='transaction-info__info-content'>
                        {debitTransactionCodes[transactionInfo.prtry.cd as keyof typeof debitTransactionCodes] ||
                            creditTransactionCodes[transactionInfo.prtry.cd as keyof typeof creditTransactionCodes]}
                    </span>
                </div>
            )}
            {!!transactionInfo.prtry && (
                <div className='transaction-info__info-item'>
                    <span className='transaction-info__info-header'>{transactionInfo.prtry.issr}:</span>
                    <span className='transaction-info__info-content'>{transactionInfo.prtry.cd}</span>
                </div>
            )}
            {!!transactionInfo.comment && (
                <div className='transaction-info__info-item'>
                    <span className='transaction-info__info-header'>Comment:</span>
                    <TextTooltip
                        maxLength={30}
                        text={transactionInfo.comment}
                    />
                </div>
            )}
        </div>
    );
};

interface ITransactionsProps {
    transactions?: Ntry[];
}

export const Transactions: React.FC<ITransactionsProps> = ({ transactions }) => {
    if (!transactions || !transactions.length) {
        return <span>No data</span>;
    }

    return (
        <div className='transaction-info'>
            {transactions.map((transaction) => (
                <TransactionInfo
                    key={transaction?.ntryDtls?.[0].txDtls?.[0].refs?.txId}
                    transactionInfo={{
                        id: transaction?.ntryDtls?.[0].txDtls?.[0].refs?.txId,
                        prtry: transaction?.ntryDtls?.[0].txDtls?.[0].bkTxCd?.prtry,
                        comment: transaction?.ntryDtls?.[0].txDtls?.[0].addtlTxInf,
                        date: transaction?.ntryDtls?.[0].txDtls?.[0].rltdDts?.txDtTm,
                        amount: formatTransactionValue(transaction.amt.value, transaction.cdtDbtInd),
                    }}
                />
            ))}
        </div>
    );
};
